module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-10.2240fed3.png";